import type { LiveStore } from 'vue-livestore';
import { tables, events } from '@/livestore/schema.js';
import type { Workplace } from '@/domain/workplace/Workplace.js';

/** Soft-deleted workplaces are purged for real after this long -- gives Drive/OneDrive sync time
 * to propagate the deletion to other devices before the row is gone for good. */
const SOFT_DELETE_RETENTION_MS = 14 * 24 * 60 * 60 * 1000; // 2 weeks

export function purgeExpiredWorkplaces(store: LiveStore): void {
  const cutoff = Date.now() - SOFT_DELETE_RETENTION_MS;
  store
    .query<Workplace>(tables.workplaces.select().where({ is_deleted: 1 }))
    .filter(wp => wp.deleted_at != null && wp.deleted_at < cutoff)
    .forEach(wp => store.commit(events.workplacePurged({ id: wp.id })));
}
